import { ChartType } from '../../types';
import * as util from './util';
const seriesPointConfig = (config, chartType) => {
    let hoverAndSelectStateConfig = { ...config };
    if (!hoverAndSelectStateConfig.highcharts) {
        hoverAndSelectStateConfig = {
            ...hoverAndSelectStateConfig,
            highcharts: {},
        };
    }
    if (!hoverAndSelectStateConfig.highcharts.plotOptions) {
        hoverAndSelectStateConfig.highcharts = {
            ...hoverAndSelectStateConfig.highcharts,
            plotOptions: {},
        };
    }
    if (chartType === ChartType.Column ||
        chartType === ChartType.StackedColumn) {
        if (!hoverAndSelectStateConfig.highcharts.plotOptions.column) {
            hoverAndSelectStateConfig.highcharts.plotOptions.column = {};
        }
        hoverAndSelectStateConfig.highcharts.plotOptions.column = {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.column,
            ...util.clipProps,
        };
    }
    if (chartType === ChartType.Bar || chartType === ChartType.StackedBar) {
        if (!hoverAndSelectStateConfig.highcharts.plotOptions.bar) {
            hoverAndSelectStateConfig.highcharts.plotOptions.Bar = {};
        }
        hoverAndSelectStateConfig.highcharts.plotOptions.bar = {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.bar,
            ...util.clipProps,
        };
    }
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.series) {
        hoverAndSelectStateConfig.highcharts.plotOptions = {
            ...hoverAndSelectStateConfig.highcharts.plotOptions,
            series: {},
        };
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
            hover: {
                ...util.hoverColumnStateProps,
            },
            select: {
                ...util.selectColumnStateProps,
            },
        },
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const pieFunnelConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
            hover: {
                ...util.hoverColumnStateProps,
            },
            select: {
                ...util.selectColumnStateProps,
            },
        },
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const lineConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        events: {
            ...util.serieMouseOverEvent,
            ...util.serieMouseOutEvent,
        },
    };
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.line) {
        hoverAndSelectStateConfig.highcharts.plotOptions.line = {};
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.line = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.line,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.series.marker = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series.marker,
        states: {
            hover: {
                ...util.hoverLineMarkerStateProps,
            },
            select: {
                ...util.selectLineMarkerStateProps,
                ...util.markerRadiusProps,
            },
        },
    };
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.series.point) {
        hoverAndSelectStateConfig.highcharts.plotOptions.series.point = {
            events: {},
        };
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.series.point.events = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series.point.events,
        ...util.clickEvent,
        ...util.contextmenuEvent,
    };
    return hoverAndSelectStateConfig;
};
const areaConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.series) {
        hoverAndSelectStateConfig.highcharts.plotOptions.series = {};
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        events: {
            ...util.serieMouseOverEvent,
            ...util.serieMouseOutEvent,
        },
    };
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.area) {
        hoverAndSelectStateConfig.highcharts.plotOptions = {
            ...hoverAndSelectStateConfig.highcharts.plotOptions,
            area: {},
        };
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.area = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.area,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
        },
        marker: {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.area.marker,
            states: {
                hover: {
                    ...util.hoverLineMarkerStateProps,
                },
                select: {
                    ...util.selectLineMarkerStateProps,
                    ...util.markerRadiusProps,
                },
            },
        },
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const scatterBubbleConfig = (config, chartType) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
        },
    };
    const markerRadiusProps = chartType === ChartType.Scatter ? util.markerRadiusProps : {};
    hoverAndSelectStateConfig.highcharts.plotOptions.series.marker = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series.marker,
        states: {
            hover: {
                ...util.hoverLineMarkerStateProps,
            },
            select: {
                ...util.selectLineMarkerStateProps,
                ...markerRadiusProps,
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.series.point = {
        events: {
            ...util.clickEvent,
            ...util.contextmenuEvent,
            ...util.pointMouseOverEvent,
            ...util.pointMouseOutEvent,
        },
    };
    return hoverAndSelectStateConfig;
};
const treemapConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        allowPointSelect: true,
        states: {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.series.states,
            hover: {
                ...util.hoverColumnStateProps,
            },
            select: {
                ...util.selectColumnStateProps,
            },
        },
        point: {
            events: {
                ...hoverAndSelectStateConfig.highcharts.plotOptions.series
                    .point,
                ...util.clickEvent,
                ...util.contextmenuEvent,
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const heatmapConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        allowPointSelect: true,
        events: {
            ...util.heatmapSeriesMouseOutEvent,
        },
        marker: {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.series.marker,
            states: {
                hover: {
                    ...util.hoverColumnLineStateProps,
                },
                select: {
                    ...util.selectColumnLineStateProps,
                },
            },
        },
        point: {
            ...hoverAndSelectStateConfig.highcharts.plotOptions.series.point,
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const lineColumnConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.line = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.line,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
        },
        events: {
            ...util.serieMouseOverEvent,
            ...util.serieMouseOutEvent,
        },
        marker: {
            states: {
                hover: {
                    ...util.hoverLineMarkerStateProps,
                },
                select: {
                    ...util.selectLineMarkerStateProps,
                    ...util.markerRadiusProps,
                },
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.column = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.column,
        ...util.clipProps,
        states: {
            inactive: {
                ...util.inactiveStateProps,
            },
            hover: {
                ...util.hoverColumnStateProps,
            },
            select: {
                ...util.selectColumnStateProps,
            },
        },
        point: {
            events: {
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const spiderWebConfig = (config) => {
    const hoverAndSelectStateConfig = { ...config };
    hoverAndSelectStateConfig.highcharts = {
        ...hoverAndSelectStateConfig.highcharts,
        plotOptions: {
            series: {
                states: {
                    inactive: {
                        ...util.inactiveStateProps,
                    },
                },
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        allowPointSelect: true,
        marker: {
            states: {
                hover: {
                    ...util.hoverLineMarkerStateProps,
                },
                select: {
                    ...util.selectLineMarkerStateProps,
                    ...util.markerRadiusProps,
                },
            },
        },
    };
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const candlestickConfig = (config) => {
    let hoverAndSelectStateConfig = { ...config };
    if (!hoverAndSelectStateConfig.highcharts) {
        hoverAndSelectStateConfig = {
            ...hoverAndSelectStateConfig,
            highcharts: {},
        };
    }
    if (!hoverAndSelectStateConfig.highcharts.plotOptions) {
        hoverAndSelectStateConfig.highcharts = {
            ...hoverAndSelectStateConfig.highcharts,
            plotOptions: {},
        };
    }
    if (!hoverAndSelectStateConfig.highcharts.plotOptions.series) {
        hoverAndSelectStateConfig.highcharts.plotOptions = {
            ...hoverAndSelectStateConfig.highcharts.plotOptions,
            series: {},
        };
    }
    hoverAndSelectStateConfig.highcharts.plotOptions.series = {
        ...hoverAndSelectStateConfig.highcharts.plotOptions.series,
        allowPointSelect: true,
        ...util.clipProps,
        states: {
            hover: {
                ...util.hoverColumnLineStateProps,
            },
            select: {
                ...util.selectColumnLineStateProps,
            },
        },
        point: {
            events: {
                ...util.clickEvent,
                ...util.contextmenuEvent,
                ...util.pointMouseOverEvent,
                ...util.pointMouseOutEvent,
            },
        },
    };
    return hoverAndSelectStateConfig;
};
const updateHoverAndSelectState = (chartType, config) => {
    switch (chartType) {
        case ChartType.Column:
        case ChartType.StackedColumn:
        case ChartType.Bar:
        case ChartType.StackedBar:
        case ChartType.Waterfall:
            return seriesPointConfig(config, chartType);
        case ChartType.Line:
            return lineConfig(config);
        case ChartType.LineColumn:
        case ChartType.LineStackedColumn:
        case ChartType.Pareto:
            return lineColumnConfig(config);
        case ChartType.Kpi:
        case ChartType.Area:
        case ChartType.StackedArea:
            return areaConfig(config);
        case ChartType.Pie:
        case ChartType.Funnel:
            return pieFunnelConfig(config);
        case ChartType.Scatter:
        case ChartType.Bubble:
            return scatterBubbleConfig(config, chartType);
        case ChartType.Heatmap:
            return heatmapConfig(config);
        case ChartType.Treemap:
            return treemapConfig(config);
        case ChartType.SpiderWeb:
            return spiderWebConfig(config);
        case ChartType.Candlestick:
            return candlestickConfig(config);
        default:
            return config;
    }
};
export { updateHoverAndSelectState };
//# sourceMappingURL=config.js.map